<template>
  <el-card>
    <el-row>
      <el-form :model="form" v-bind="formProps.form" :rules="{}">
        <el-form-item :label="$t('device.bankCode')" prop="bankCode">
          <el-input v-model.trim="form.bankCode" />
        </el-form-item>
        <el-form-item :label="$t('device.serialNumber')" prop="serialNumber">
          <el-input v-model.trim="form.serialNumber" />
        </el-form-item>
        <el-form-item :label="$t('device.bankAccount')" prop="bankAccount">
          <el-input v-model="form.bankAccount" />
        </el-form-item>
        <el-form-item :label="$t('device.remark')">
          <el-select size="mini" v-model="form.remark" clearable>
            <el-option
              v-for="(item, index) in describeList"
              :key="index"
              :value="item"
              :label="item"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button size="mini" type="warning" @click="handleEmpty()">{{
            $t('btns.empty')
          }}</el-button>
          <el-button size="mini" type="primary" @click="handleSearch()">{{
            $t('btns.search')
          }}</el-button>
          <el-button
            size="mini"
            type="primary"
            @click="handleEditor()"
            v-if="permission.indexOf('bank:account:insert') > -1"
            >{{ $t('btns.add') }}</el-button
          >
          <el-button size="mini" type="primary" @click="updateShow = true">{{
            $t('device.exportIn')
          }}</el-button>

          <el-button size="mini" type="primary">
            <router-link tag="a" :to="{ name: 'paybankhistory' }">
              {{ $t('device.history') }}
            </router-link>
          </el-button>
        </el-form-item>
      </el-form>
    </el-row>
    <div class="header-table">
      <div>
        <span style="margin-left: 20px"
          >{{ $t('device.balance') }}：{{ balance | toThousands }}</span
        >
        <span style="margin-left: 20px"
          >{{ $t('device.successTodayAmount') }}：{{ totalSuccessTodayAmount | toThousands }}</span
        >
        <span style="margin-left: 20px"
          >{{ $t('device.withdrawTodayAmount') }}：{{
            totalWithdrawTodayAmount | toThousands
          }}</span
        >
      </div>
      <el-switch
        v-if="true"
        v-model="refresh"
        @change="refTableData"
        :active-text="$t('btns.start1')"
        :inactive-text="$t('btns.stop1')"
      >
      </el-switch>
      <el-button
        v-if="tableData.length && permission.indexOf('orderRecord:payout:export') > -1"
        @click="handleExport()"
      >
        {{ $t('btns.export') }}
      </el-button>
    </div>

    <!-- <el-row>
      <div style="display: flex; flex-direction: row; align-items: center">
        <el-button size="mini" type="danger" @click="alldel()">{{
          $t('device.all.del')
        }}</el-button>

      </div>
    </el-row> -->
    <el-row>
      <el-table
        v-loading="tableLoading"
        :data="tableList"
        :header-cell-style="{ 'text-align': 'center' }"
        :cell-style="{ textAlign: 'center' }"
        :row-key="rowKey"
        stripe
        @selection-change="handleSelectionChange"
      >
        <!-- <el-table-column type="selection" width="55" :reserve-selection="true"> </el-table-column> -->

        <!--        <el-table-column width="120px" prop="id" align="center" :label="$t('device.id')" />-->
        <el-table-column type="index" label="#"></el-table-column>
        <el-table-column
          width="120px"
          prop="serialNumber"
          align="center"
          :label="$t('device.serialNumber')"
        />
        <el-table-column
          width="120px"
          prop="bankAccount"
          align="center"
          :label="$t('device.bankAccount')"
        />

        <el-table-column
          width="120px"
          prop="bankCode"
          align="center"
          :label="$t('device.bankCode')"
        />

        <el-table-column
          width="120px"
          prop="payName"
          align="center"
          :label="$t('device.payName')"
        />
        <el-table-column
          width="80px"
          prop="proQrStatus"
          align="center"
          :label="$t('device.proQrStatus')"
        >
          <template slot-scope="{ row }">
            <el-switch
              v-model="row.proQrStatus"
              :active-value="1"
              :inactive-value="2"
              active-color="#13ce66"
              inactive-color="#ff4949"
              @change="(val) => rowSelectChange(val, row, 'proQrStatus')"
            >
            </el-switch>
          </template>
        </el-table-column>

        <el-table-column
          width="80px"
          prop="bankQrStatus"
          align="center"
          :label="$t('device.bankQrStatus')"
        >
          <template slot-scope="{ row }">
            <el-switch
              v-model="row.bankQrStatus"
              :active-value="1"
              :inactive-value="2"
              active-color="#13ce66"
              inactive-color="#ff4949"
              @change="(val) => rowSelectChange(val, row, 'bankQrStatus')"
            >
            </el-switch>
          </template>
        </el-table-column>

        <!-- <el-table-column
          width="80px"
          prop="momoBankStatus"
          align="center"
          :label="$t('device.momoBankStatus')"
        >
          <template slot-scope="{ row }">
            <el-switch
              v-model="row.momoBankStatus"
              :active-value="1"
              :inactive-value="2"
              active-color="#13ce66"
              inactive-color="#ff4949"
              @change="(val) => rowSelectChange(val, row, 'momoBankStatus')"
            >
            </el-switch>
          </template>
        </el-table-column> -->

        <el-table-column
          width="80px"
          prop="bankTransferStatus"
          align="center"
          :label="$t('device.bankTransferStatus')"
        >
          <template slot-scope="{ row }">
            <el-switch
              v-model="row.bankTransferStatus"
              :active-value="1"
              :inactive-value="2"
              active-color="#13ce66"
              inactive-color="#ff4949"
              @change="(val) => rowSelectChange(val, row, 'bankTransferStatus')"
            >
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column width="80px" prop="momoBankStatus" :label="$t('device.momoBankStatus')">
          <template slot-scope="{ row }">
            <el-switch
              v-model="row.momoBankStatus"
              :active-value="1"
              :inactive-value="2"
              active-color="#13ce66"
              inactive-color="#ff4949"
              @change="(val) => rowSelectChange(val, row, 'momoBankStatus')"
            >
            </el-switch>
          </template>
        </el-table-column>
        <!-- <el-table-column
          width="120px"
          prop="zaloBankStatus"
          align="center"
          :label="$t('device.zalobankStatus')"
        >
          <template slot-scope="{ row }">
            <el-switch
              v-model="row.zaloBankStatus"
              :active-value="1"
              :inactive-value="2"
              active-color="#13ce66"
              inactive-color="#ff4949"
              @change="(val) => rowSelectChange(val, row, 'zaloBankStatus')"
            >
            </el-switch>
          </template>
        </el-table-column> -->
        <!-- <el-table-column
          width="120px"
          prop="vtpayBankStatus"
          align="center"
          :label="$t('device.vtpbankStatus')"
        >
          <template slot-scope="{ row }">
            <el-switch
              v-model="row.vtpayBankStatus"
              :active-value="1"
              :inactive-value="2"
              active-color="#13ce66"
              inactive-color="#ff4949"
              @change="(val) => rowSelectChange(val, row, 'vtpayBankStatus')"
            >
            </el-switch>
          </template>
        </el-table-column> -->

        <el-table-column
          width="80px"
          prop="apiStatus"
          align="center"
          :label="$t('device.apiStatus')"
        >
          <template slot-scope="{ row }">
            <el-switch
              v-model="row.apiStatus"
              :active-value="1"
              :inactive-value="2"
              active-color="#13ce66"
              inactive-color="#ff4949"
              @change="(val) => rowSelectChange(val, row, 'apiStatus')"
            >
            </el-switch>
          </template>
        </el-table-column>

        <el-table-column
          width="80px"
          prop="autoWithdrawalStatus"
          align="center"
          :label="$t('device.autoWithdrawalStatus')"
        >
          <template slot-scope="{ row }">
            <el-switch
              v-model="row.autoWithdrawalStatus"
              :active-value="1"
              :inactive-value="2"
              active-color="#13ce66"
              inactive-color="#ff4949"
              @change="(val) => rowSelectChange(val, row, 'autoWithdrawalStatus')"
            >
            </el-switch>
          </template>
        </el-table-column>

        <el-table-column width="120px" prop="balance" align="center" :label="$t('device.balance')">
          <template slot-scope="{ row }">
            <span :style="{ color: row.balance > 30000000 ? 'red' : '' }">{{
              row.balance | toAmountotal
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          width="120px"
          prop="ownerMerchantNo"
          align="center"
          :label="$t('device.owner_merchant_no')"
        />
        <el-table-column
          width="100px"
          prop="balanceUpdateTime"
          align="center"
          :label="$t('device.updateDate')"
        >
          <template slot-scope="{ row }">
            <span :style="getRowStyle(row)">{{ row.balanceUpdateTime }}</span>
          </template>
        </el-table-column>
        <el-table-column
          width="120px"
          prop="successTodayAmount"
          align="center"
          :label="$t('device.successTodayAmount')"
        >
          <template slot-scope="{ row }">
            <span>{{ row.successTodayAmount | toAmountotal }}</span>
          </template>
        </el-table-column>
        <el-table-column
          width="120px"
          prop=" withdrawTodayAmount"
          align="center"
          :label="$t('device.withdrawTodayAmount')"
        >
          <template slot-scope="{ row }">
            <span>{{ row.withdrawTodayAmount | toAmountotal }}</span>
          </template>
        </el-table-column>
        <el-table-column
          width="120px"
          prop="reservedAmount"
          align="center"
          :label="$t('device.reservedAmount')"
        >
          <template slot-scope="{ row }">
            <span>{{ row.reservedAmount | toAmountotal }}</span>
          </template>
        </el-table-column>
        <el-table-column
          width="120px"
          prop="autoWithdrawalAmount"
          align="center"
          :label="$t('device.autoWithdrawalAmount')"
        >
          <template slot-scope="{ row }">
            <span>{{ row.autoWithdrawalAmount | toAmountotal }}</span>
          </template>
        </el-table-column>
        <el-table-column
          width="190px"
          prop="updateDate"
          align="center"
          :label="$t('merchantBalance.label.updateDate')"
        />
        <el-table-column width="190px" prop="remark" align="center" :label="$t('device.remark')" />
        <el-table-column align="center" :label="$t('channel.label.action')" width="300px">
          <template slot-scope="{ row }">
            <el-button slot="reference" type="primary" size="mini" @click="getBalance(row.id)">
              {{ $t('device.pullBalance') }}
            </el-button>
            <el-popconfirm
              :ref="`popover-${row.id}`"
              :key="row.id"
              :title="$t('orders.tip.danger')"
              @confirm="handleEditor(row)"
              v-if="permission.indexOf('bank:account:update') > -1"
            >
              <el-button slot="reference" type="primary" size="mini">
                {{ $t('btns.editor') }}
              </el-button>
            </el-popconfirm>
            <div style="margin: 10px; display: inline-block"></div>
            <el-popconfirm
              :ref="`popover-${row.id}`"
              :key="row.id + 's'"
              :title="$t('orders.tip.danger')"
              @confirm="handleDel(row)"
              v-if="permission.indexOf('bank:account:delete') > -1"
            >
              <el-button slot="reference" type="danger" size="mini">
                {{ $t('btns.del') }}
              </el-button>
            </el-popconfirm>
            <div style="margin: 0px 10px; display: inline-block"></div>
            <paybankVcb :row="row" @getTable="getTableData"></paybankVcb>
            <!-- <el-switch v-model="row.apiStatus" :active-value="1" :inactive-value="0" active-color="#13ce66"
              inactive-color="#ff4949" @change="(val) => rowSelectChange(val,row)">
            </el-switch> -->
          </template>
        </el-table-column>

        <el-table-column
          width="120px"
          prop="minimumAmount"
          align="center"
          :label="$t('device.minimumAmount')"
        />
        <el-table-column
          width="120px"
          prop="maximumAmount"
          align="center"
          :label="$t('device.maximumAmount')"
        />
        <el-table-column
          width="190px"
          prop="createBy"
          align="center"
          :label="$t('merchantBalance.label.createAcct')"
        />
        <el-table-column
          width="190px"
          prop="createDate"
          align="center"
          :label="$t('merchantBalance.label.createTime')"
        />
        <el-table-column
          width="190px"
          prop="updateBy"
          align="center"
          :label="$t('merchantBalance.label.updateBy')"
        />
      </el-table>
    </el-row>

    <v-pagination v-model="pagination" :total="tableData.rows" @update="getTableData" />

    <v-editor
      ref="editor"
      :isAdd="isAdd"
      :merchantList="merchantList"
      @doConfAdd="doConfAdd"
      @doConfUpdate="doConfUpdate"
    />

    <!-- 添加用户的对话框 -->
    <el-dialog
      :title="$t('accountmanager.addUser')"
      :visible.sync="addUserDialogVisible"
      width="50%"
      @close="addUserDialogVisible = false"
    >
      <!-- 内容主体区域 -->
      <el-form :model="addForm" :rules="addFormRules" ref="addFormRef" label-width="130px">
        <el-form-item :label="$t('device.limits')" prop="limits">
          <el-input v-model.trim="addForm.limits"></el-input>
        </el-form-item>
        <el-form-item :label="$t('device.monthLimits')" prop="monthLimits">
          <el-input v-model.trim="addForm.monthLimits"></el-input>
        </el-form-item>
      </el-form>
      <!-- 底部区域 -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="addUserDialogVisible = false">
          {{ $t('accountmanager.cancel') }}
        </el-button>
        <el-button type="primary" @click="allEditor">{{ $t('accountmanager.confirm') }}</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :title="$t('device.updates')"
      :visible.sync="updateShow"
      width="50%"
      @close="closeUpdate()"
    >
      <div class="drop-zone text-center">
        <input
          type="file"
          name="file"
          ref="fileRef"
          @change="getExcel($event)"
          accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        />
        <div>
          <div class="upload-icon">
            <el-button v-if="!fileName"> {{ $t('device.selectFile') }}</el-button>
            <i class="el-icon-upload" style="font-size: 60px; margin-left: 10px"></i>
          </div>
          <p
            style="line-height: 20px"
            ng-bind-html="self.langs.DEPOSITIMPORT_DragFile"
            class="ng-binding"
          >
            {{ $t('device.down.a1') }}
            <br />{{ $t('device.down.a2') }}
            <!-- <em
              style="color: #409eff; cursor: pointer"
              @click="handleExport"
              href="/devices/import/template"
              target="_blank"
              >{{ $t('device.down.a3') }}</em -->
            >
          </p>
        </div>
        <div v-if="fileName" style="margin-top: 10px">
          <span> {{ $t('device.SelectedFile') }}:</span> <el-tag type="info">{{ fileName }}</el-tag>
        </div>
      </div>
      <div slot="footer" style="text-align: right; margin: 20px 0">
        <el-button size="mini" type="warning" @click="handleExport">
          {{ $t('device.down.a3') }}
        </el-button>
        <el-button size="mini" @click="updateShow = false">
          {{ $t('device.down.close') }}
        </el-button>
        <el-button size="mini" type="primary" @click="uploadFile()">
          {{ $t('device.down.confirm') }}
        </el-button>
      </div>
    </el-dialog>

    <!-- <el-dialog :visible.sync="historyShow" width="80%">
      <history></history>
    </el-dialog> -->
  </el-card>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import PaybankVcb from './paybank-vcb.vue';
import { debounce } from 'lodash';
import device_API from '@/api/device';
import vEditor from './editorBank';
import merchantApi from '@/api/merchant';
import orderApi from '@/api/orders';
// import history from './paybankhistory.vue'
export default {
  name: 'channelConf',
  components: {
    vEditor,
    PaybankVcb
  },
  data() {
    return {
      tableLoading: false,
      refresh: true,
      refInterval: null,
      totalSuccessTodayAmount: '',
      totalWithdrawTodayAmount: '',
      describeList: [],
      balance: '0.00',
      form: {
        //银行编码
        bankCode: '',
        //设备号
        serialNumber: '',
        //银行收款账号
        bankAccount: '',
        //银行登录账号
        loginAccount: '',
        remark: ''
      },
      historyShow: false,
      addForm: {
        limits: '',
        monthLimits: ''
      },
      pagination: {
        no: 1,
        size: 100
      },
      connectionStatusOption: this.$t('device.connectionStatusOption'),
      options: this.$t('device.add_connectionStatusOption'),
      channelTypeData: {},
      tableData: {
        row: 0
      },
      select: [],
      connectionStatus: 0,
      addUserDialogVisible: false,
      // 添加账号的验证规则对象
      addFormRules: {
        limits: [
          {
            required: true,
            message: this.$t('device.limits'),
            trigger: 'blur'
          }
        ],
        monthLimits: [
          {
            required: true,
            message: this.$t('device.monthLimits'),
            trigger: 'blur'
          }
        ]
      },
      updateShow: false,
      totalData: null,
      isAdd: false,
      excelformData: null,
      fileName: '',
      timeThresholdMinutes: 3, // 时间阈值，大于该阈值的数据显示红色
      merchantList: []
    };
  },
  computed: {
    tableList() {
      return this.tableData.list || [];
    },
    ...mapGetters(['permission']),
    channelTypeList() {
      return Object.keys(this.channelTypeData) || [];
    },
    channelCodeList() {
      if (Array.isArray(this.channelTypeData[this.form.channelType])) {
        return this.channelTypeData[this.form.channelType].length > 0
          ? this.channelTypeData[this.form.channelType]
          : '';
      } else {
        return '';
      }
    },
    statusData() {
      return [
        {
          label: this.$t('status.success2'),
          type: 'success',
          value: 1
        },
        {
          label: this.$t('status.error2'),
          type: 'error',
          value: 0
        }
      ];
    }
  },
  created() {
    this.init();
    this.getDescribe();
    this.getMerchantData();
  },
  mounted() {
    // this.getConfType();
    this.getTableData();
    this.refTableData();
  },
  beforeDestroy() {
    this.refInterval && clearInterval(this.refInterval);
  },

  methods: {
    rowKey(row) {
      return row.id;
    },
    labelGet(index) {
      index = Number(index);
      return this.options[index] ? this.options[index].label : '';
    },
    async rowSelectChange(val, row, key) {
      this.$confirm(!row[key] ? this.$t('device.changestate') : this.$t('device.changestateoff'))
        .then(async () => {
          let params = {
            ...row,
            operation: 'status'
          };
          if (key) {
            params[key] = val;
          } else {
            params.connectionStatus = val;
          }
          const { data } = await device_API.b_update(params);
          if (data.code == 200) {
            this.$message.success(data.msg);
          } else {
            this.$message.error(data.msg);
          }
          this.getTableData();
        })
        .catch(() => {
          row[key] = !row[key];
        });
    },
    async alldel() {
      if (this.select.length == 0) {
        this.$message({
          type: 'info',
          message: '请先选择'
        });
        return;
      }
      this.$confirm('此操作将永久删除该内容, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
          let ids = this.select.map((it) => it.id);
          let params = {
            //类型(1:momo,2:zalo,3:viettel)
            type: 1,
            //id 数组
            idList: ids
          };
          const { data } = await device_API.alldels(params);
          if (data.code == 200) {
            this.$message.success(data.msg);
          } else {
            this.$message.error(data.msg);
          }
          this.getTableData();
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
    },
    async allEditor() {
      if (this.select.length == 0) {
        this.$message({
          type: 'info',
          message: '请先选择'
        });
        return;
      }
      let ids = this.select.map((it) => it.id);
      let params = {
        //类型(1:momo,2:zalo,3:viettel)
        type: 1,
        //id 数组
        idList: ids,
        //批量修改限额(当天限额和当月限额)
        limits: this.addForm.limits,
        monthLimits: this.addForm.monthLimits
      };
      const { data } = await device_API.offOrturn(params);
      if (data.code == 200) {
        this.$message.success(data.msg);
        this.addUserDialogVisible = false;
        this.addForm = {
          limits: '',
          monthLimits: ''
        };
      } else {
        this.$message.error(data.msg);
      }
      this.getTableData();
    },
    async handleExport() {
      const { data } = await device_API.downtemp();
      if (data) {
        const BLOB = data;
        const fileReader = new FileReader();
        fileReader.readAsDataURL(BLOB);
        fileReader.onload = (event) => {
          // 处理load事件。该事件在读取操作完成时触发
          // 新建个下载的a标签，完成后移除。
          let a = document.createElement('a');
          a.download = `Merchant-WithdrawList${Number(new Date())}.xlsx`;
          a.href = event.target.result;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        };
      } else {
        this.$message.error(this.$t('status.error'));
      }
    },
    formatParams() {
      return {
        ...Object.keys(this.form).reduce((acc, key) => {
          acc[key] = this.form[key];
          return acc;
        }, {})
      };
    },
    async allSelectChange(val) {
      if (this.select.length == 0) {
        this.$message({
          type: 'info',
          message: '请先选择'
        });
        return;
      }
      let ids = this.select.map((it) => it.id);
      let params = {
        //类型(1:momo,2:zalo,3:viettel)
        type: 1,
        //id 数组
        idList: ids,
        //批量开启1
        //批量关闭0
        connectionStatus: this.connectionStatus
      };
      const { data } = await device_API.offOrturn(params);
      if (data.code == 200) {
        this.$message.success(data.msg);
      } else {
        this.$message.error(data.msg);
      }
      this.getTableData();
    },
    handleSelectionChange(list) {
      console.log(list);
      this.select = list;
    },
    init() {
      this.handleSearch = debounce(this._handleSearch, 300);
      /* ----------------------------- element -props ----------------------------- */
      this.formProps = {
        form: {
          ref: 'form',
          'label-width': 'auto',
          inline: true,
          size: 'small',
          rules: {
            channelCode: [
              {
                required: true,
                message: this.$t('channel.rules.channelCode'),
                trigger: 'change'
              }
            ],
            channelType: [
              {
                required: true,
                message: this.$t('channel.rules.channelType'),
                trigger: 'change'
              }
            ]
          }
        }
      };
      this.serviceTypes = ['api', 'auto'];
    },

    /* ---------------------------------- 格式化数据 --------------------------------- */
    formatParams() {
      return {
        ...Object.keys(this.form).reduce((acc, key) => {
          if (this.form[key] === 0 || this.form[key]) {
            acc[key] = this.form[key];
          }
          if (key === 'channelCode') {
            acc.channelCode = '';
          }
          return acc;
        }, {})
        // ...this.pagination
      };
    },
    /* --------------------------------- 获取分页数据 --------------------------------- */
    async getTableData() {
      this.tableLoading = true;
      device_API.bank_balance(this.form).then((res) => {
        this.balance = res.data.data.totalBalance;
        this.totalWithdrawTodayAmount = res.data.data.totalWithdrawTodayAmount;
        this.totalSuccessTodayAmount = res.data.data.totalSuccessTodayAmount;
        this.tableLoading = false;
      });
      const { data } = await device_API.b_listpage({
        query: this.form,
        no: this.pagination.no,
        size: this.pagination.size
      });
      if (data && data.code == 200) {
        this.tableData = data.data;
        this.tableLoading = false;
      } else {
        this.tableLoading = false;
      }
    },

    async uploadFile() {
      if (!this.excelformData) {
        this.$message({
          message: this.$t('device.down.selectfile'),
          type: 'warning'
        });
        return;
      }
      try {
        const response = await device_API.doExportin(this.excelformData);
        if (response.code == 200 || response.data.code == 200) {
          this.$message({
            message: this.$t('device.down.ImportSuccess'),
            type: 'success'
          });
          this.getTableData();
          this.excelformData = null; // 清空 excelformData
          this.$refs.fileRef.value = ''; // 清空文件输入框
          this.updateShow = false;
        }
      } catch (error) {
        this.$message({
          message: this.$t('device.down.Importfailed'),
          type: 'error'
        });
      }
    },

    getExcel(e) {
      this.excelformData = new FormData();
      const file = e.target.files[0];
      this.excelformData.append('file', e.target.files[0]);
      this.excelformData.append('userName', 'test');
      this.fileName = file.name; //显示上传文件名
      // device_API.doExportin(this.excelformData).then((response) => {
      //   if (response.code == 0) {
      //     this.$message({
      //       message: 'success',
      //       type: 'success'
      //     });
      //     this.getTable();
      //     e.target.value = '';
      //   }
      // });
    },

    closeUpdate() {
      this.excelformData = null; //清空 excelformData
      (this.fileName = ''), //清空文件名
        (this.$refs.fileRef.value = ''); // 清空文件输入框
      this.updateShow = false;
    },

    async doConfAdd(formUpdate, cb) {
      const params = {
        ...formUpdate,
        ownerMerchantNo: Array.isArray(formUpdate.ownerMerchantNo)
          ? formUpdate.ownerMerchantNo.join(',')
          : formUpdate.ownerMerchantNo || ''
      };
      const { data } = await device_API.b_insert(params);
      if (data.code == 200) {
        this.$message.success(data.msg);
        this.$refs.editor.dialogVisible = false;
      } else {
        this.$message.error(data.msg);
      }
      this.getTableData();
      this.getDescribe();
    },

    async doConfUpdate(formUpdate, cb) {
      const params = {
        ...formUpdate,
        ownerMerchantNo: Array.isArray(formUpdate.ownerMerchantNo)
          ? formUpdate.ownerMerchantNo.join(',')
          : formUpdate.ownerMerchantNo || ''
      };
      const { data } = await device_API.b_update(params);
      if (data.code == 200) {
        this.$message.success(data.msg);
        this.$refs.editor.dialogVisible = false;
      } else {
        this.$message.error(data.msg);
      }
      this.getTableData();
      this.getDescribe();
    },
    /* --------------------------------- 事件驱动函数 --------------------------------- */
    handleEmpty() {
      this.form = {
        //银行编码
        bankCode: '',
        //设备号
        serialNumber: '',
        //银行收款账号
        bankAccount: '',
        //银行登录账号
        loginAccount: '',
        //描述
        remark: ''
      };
    },
    handleEditor(row) {
      if (row) {
        this.isAdd = false;
      } else {
        this.isAdd = true;
      }
      this.$refs.editor.init(row);
    },
    async handleDel(row) {
      const { data } = await device_API.b_deletes({ id: row.id });
      if (data.code == 200) {
      } else {
        this.$message.error(data.msg);
      }
      this.getTableData();
    },
    _handleSearch() {
      this.$refs.form.validate(async (valid) => valid && this.getTableData());
    },

    //描述查询
    async getDescribe() {
      const { data } = await merchantApi.getDescribeList();
      if (data.code == 200) {
        this.describeList = data.data;
      }
    },

    //定时刷新
    refTableData() {
      if (this.refresh) {
        this.refInterval = setInterval(() => {
          this.getTableData();
        }, 1000 * 180);
      } else {
        clearInterval(this.refInterval);
      }
    },
    getBalance(id) {
      device_API.getBalance({ id }).then((res) => {
        if (res.data.code === 200) {
          const { data } = res.data;
          this.$message({
            message: this.$t('userTransaction.label.balance') + ':' + data,
            type: 'success'
          });
          this.getTableData();
        }
      });
    },

    //更新时间大于3分钟变红
    getRowStyle(row) {
      if (!row.balanceUpdateTime) {
        return {}; // 如果时间无效，返回默认样式
      }
      const currentTime = new Date().getTime(); // 获取当前时间
      const createdTime = new Date(row.balanceUpdateTime).getTime(); // 解析行数据中的创建时间
      // 计算时间差（单位：毫秒）
      const timeDifference = currentTime - createdTime;
      // 将时间差转换为分钟
      const timeDifferenceMinutes = Math.abs(timeDifference / (1000 * 60));

      if (timeDifferenceMinutes > this.timeThresholdMinutes) {
        return { color: 'red' }; // 大于阈值，显示红色
      } else {
        return {};
      }
    },

    async getMerchantData() {
      const { data } = await orderApi.getMerchantData({
        data: { merchantType: 2, merchantStatus: 0 }
      });
      if (data) {
        if (data.code == 200) {
          this.merchantList = Array.isArray(data.data)
            ? data.data.map((item) => item.merchantNo)
            : [];
        } else {
          this.$message.error(data.msg);
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.header-table {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: rgba(0, 0, 0, 0.2);
  padding-right: 40px;
  height: 70px;
}

/deep/ .el-upload-dragger {
  width: 100%;
}

/deep/ .el-upload {
  width: 100%;
}

.drop-zone {
  text-align: center;
  position: relative;
  padding: 19px 0 0;
  margin-top: 10px;
  width: 100%;
  /* height: 150px; */
  color: #8f8f8f;
  box-sizing: border-box;
  /* background-color: #f5f5f5; */
  border-radius: 4px;
  border-top: dashed 3px transparent;
  cursor: pointer;

  input {
    width: 100%;
    position: absolute;
    font-size: 100px;
    right: 0;
    top: 0;
    opacity: 0;
    filter: alpha(opacity=0);
    cursor: pointer;
  }
}

/deep/ .el-button a {
  text-decoration: none;
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/device/paybank.vue